import Box from '@mui/material/Box';
import { DataGrid, GridColDef, GridDensity, GridRowsProp, ToolbarPropsOverrides } from '@mui/x-data-grid';
import { GridToolbarProps } from '@mui/x-data-grid/internals';
import { JSXElementConstructor } from 'react';

export type DataHubTableProps = {
  rows: GridRowsProp;
  columns: GridColDef[];
  showToolbar?: boolean;
  customToolbar?: JSXElementConstructor<GridToolbarProps & ToolbarPropsOverrides> | undefined;
  density?: GridDensity;
  cellFontSize?: string | number; // e.g., '16px' or 16
  headerFontSize?: string | number; // e.g., '16px' or 16
};
export default function DataHubTable({
  rows,
  columns,
  showToolbar = false,
  customToolbar,
  density = 'standard',
  cellFontSize = 'inherit',
  headerFontSize = 'inherit',
}: DataHubTableProps) {
  return (
    <Box sx={{ width: '100%' }}>
      {/* height: 'calc(100vh - 64px - 24px - 24px - 24.33px)' // screenHeight - navBarHeight - paddingTop - paddingBottom - InfoBoxHeight - paddingTopBottom*/}
      <DataGrid
        rows={rows}
        columns={columns}
        density={density}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10]}
        disableRowSelectionOnClick
        sx={{
          '& .MuiDataGrid-cell': {
            fontSize: cellFontSize,
          },
          '& .MuiDataGrid-columnHeader': {
            fontSize: headerFontSize,
          },
        }}
        showToolbar={showToolbar}
        slots={{ toolbar: customToolbar }}
      />
    </Box>
  );
}